import { render, staticRenderFns } from "./CardConfirmacaoCancelamento.vue?vue&type=template&id=12f467bf&scoped=true&"
import script from "./CardConfirmacaoCancelamento.vue?vue&type=script&lang=js&"
export * from "./CardConfirmacaoCancelamento.vue?vue&type=script&lang=js&"
import style0 from "./CardConfirmacaoCancelamento.vue?vue&type=style&index=0&id=12f467bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f467bf",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f467bf')) {
      api.createRecord('12f467bf', component.options)
    } else {
      api.reload('12f467bf', component.options)
    }
    module.hot.accept("./CardConfirmacaoCancelamento.vue?vue&type=template&id=12f467bf&scoped=true&", function () {
      api.rerender('12f467bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Perfil/components/CardConfirmacaoCancelamento.vue"
export default component.exports